var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04D7478B-6179-42B7-8E95-69FD5B1F2BFB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Details",
    transform: "translate(-1247.000000, -109.000000)",
    fill: "#7B98B5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1219.900000, 97.714967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-New-Icon",
    transform: "translate(27.488020, 11.879856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4568524,1.80296548 L12.4568524,12.4568524 L1.80296548,12.4568524 C1.53153722,12.4568524 1.31124762,12.677142 1.31124762,12.9485703 C1.31124762,13.2199985 1.53153722,13.4402881 1.80296548,13.4402881 L12.9485703,13.4402881 C13.2199985,13.4402881 13.4402881,13.2199985 13.4402881,12.9485703 L13.4402881,1.80296548 C13.4402881,1.53153722 13.2199985,1.31124762 12.9485703,1.31124762 C12.677142,1.31124762 12.4568524,1.53153722 12.4568524,1.80296548 Z M11.4734167,1.14734167 C11.4734167,0.84313222 11.3524541,0.551379624 11.1374095,0.336007203 C10.9220371,0.120962593 10.6302845,0 10.326075,0 L1.14734167,0 C0.84313222,0 0.551379624,0.120962593 0.336007203,0.336007203 C0.120962593,0.551379624 0,0.84313222 0,1.14734167 L0,10.326075 C0,10.6302845 0.120962593,10.9220371 0.336007203,11.1374095 C0.551379624,11.3524541 0.84313222,11.4734167 1.14734167,11.4734167 L10.326075,11.4734167 C10.6302845,11.4734167 10.9220371,11.3524541 11.1374095,11.1374095 C11.3524541,10.9220371 11.4734167,10.6302845 11.4734167,10.326075 L11.4734167,1.14734167 Z M5.24499048,5.24499048 L3.76983691,5.24499048 C3.49840865,5.24499048 3.27811905,5.46528008 3.27811905,5.73670834 C3.27811905,6.0081366 3.49840865,6.2284262 3.76983691,6.2284262 L5.24499048,6.2284262 L5.24499048,7.70357977 C5.24499048,7.97500803 5.46528008,8.19529763 5.73670834,8.19529763 C6.0081366,8.19529763 6.2284262,7.97500803 6.2284262,7.70357977 L6.2284262,6.2284262 L7.70357977,6.2284262 C7.97500803,6.2284262 8.19529763,6.0081366 8.19529763,5.73670834 C8.19529763,5.46528008 7.97500803,5.24499048 7.70357977,5.24499048 L6.2284262,5.24499048 L6.2284262,3.76983691 C6.2284262,3.49840865 6.0081366,3.27811905 5.73670834,3.27811905 C5.46528008,3.27811905 5.24499048,3.49840865 5.24499048,3.76983691 L5.24499048,5.24499048 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTask);
export default __webpack_public_path__ + "static/media/create-task.5f85365f30f9d504c8785aba34b35cfc.svg";
export { ForwardRef as ReactComponent };